// extracted by mini-css-extract-plugin
module.exports = {"container":"Tile_container__pq9vm","loading":"Tile_loading__1AhYa","value":"Tile_value__iW9BB"};